var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-template',{attrs:{"title":_vm.title,"show-device-picker":_vm.showDevicePicker,"layout":_vm.layout}},[_c('Color',{attrs:{"un-formatted":_vm.unFormatted,"variable":_vm.variable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }